import {gql, useLazyQuery} from '@apollo/client';
import {imagoSSOLink} from '../schema-types/imagoSSOLink';

export const IMAGO_SSO_LINK = gql`
  query imagoSSOLink {
    imagoSsoRedirectLink {
      uri
      error
    }
  }
`;

export default function useImagoSSO() {
  const [getImagoLink, {data, loading}] = useLazyQuery<imagoSSOLink>(IMAGO_SSO_LINK);

  return {
    imagoLink: data?.imagoSsoRedirectLink?.uri,
    imagoLoading: loading,
    imagoError: data?.imagoSsoRedirectLink?.error,
    getImagoLink,
  };
}
